module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-button', {
    attrs: {
      "type": "warning",
      "plain": "",
      "icon": "el-icon-download"
    },
    on: {
      "click": function($event) {
        return _vm.clickEvent()
      }
    }
  }, [_vm._v(_vm._s(_vm.btnCon))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@11.3.4/~/vue-loader/lib/template-compiler?{"id":"data-v-ee4cbcc4"}!./~/.store/vue-loader@11.3.4/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/myButton/ExportButton.vue
// module id = 1969
// module chunks = 1